/* global CanvasJS, chart_data -- provided by the page (a Blade-injected value or a third-party script tag), not declared in this file */
$(function () {
    $('[data-toggle="tooltip"]').tooltip();

    // Scroll to reviews
    $('.goto-reviews').on('click', () => {
        if (navigator.userAgent.match(/(iPod|iPhone|iPad|Android)/)) {
            $('body, html').animate({
                scrollTop: $('#listing_reviews').offset().top,
            }, 500);
        } else {
            $('body, html').animate({
                scrollTop: $('#listing_reviews').offset().top - 164,
            }, 500);
        }
    });

    CanvasJS.addColorSet('track5', [
        '#095199',
        '#2386c8',
        '#91ccee',
        '#ebb644',
        '#a76dc3',
        '#6c3984',
        '#a34056',
        '#b0a7e8',
    ]);

    // Singles chart
    if (typeof chart_data.singles !== 'undefined') {
        new CanvasJS.Chart('singles_chart', {
            animationEnabled: true,
            colorSet: 'track5',
            legend: {
                cursor: 'pointer',
                horizontalAlign: 'right',
                verticalAlign: 'center',
            },
            data: [{
                type: 'pie',
                showInLegend: true,
                toolTipContent: '{name}: <strong>{y}%</strong>',
                dataPoints: chart_data.singles,
            }],
        }).render();
    }

    // Commute chart
    if (typeof chart_data.commute !== 'undefined') {
        new CanvasJS.Chart('commute_chart', {
            animationEnabled: true,
            colorSet: 'track5',
            axisX: {suffix: ' mins'},
            axisY: {suffix: '%'},
            data: [{
                type: 'column',
                legendMarkerColor: 'grey',
                dataPoints: chart_data.commute,
            }],
        }).render();
    }

    // Temperature chart
    if (typeof chart_data.temperature !== 'undefined') {
        new CanvasJS.Chart('temperature_chart', {
            animationEnabled: true,
            colorSet: 'track5',
            toolTip: {shared: true},
            legend: {cursor: 'pointer'},
            axisY: {suffix: '°F'},
            data: chart_data.temperature,
        }).render();
    }

    // Age chart
    if (typeof chart_data.age !== 'undefined') {
        new CanvasJS.Chart('age_chart', {
            animationEnabled: true,
            colorSet: 'track5',
            legend: {
                cursor: 'pointer',
                horizontalAlign: 'right',
                verticalAlign: 'center',
            },
            data: [{
                type: 'pie',
                showInLegend: true,
                toolTipContent: '{name}: <strong>{y}%</strong>',
                dataPoints: chart_data.age,
            }],
        }).render();
    }

    // Children chart
    if (typeof chart_data.children !== 'undefined') {
        new CanvasJS.Chart('children_chart', {
            animationEnabled: true,
            colorSet: 'track5',
            data: [{
                type: 'doughnut',
                startAngle: 60,
                //showInLegend: true,
                toolTipContent: '#percent%',
                dataPoints: chart_data.children,
            }],
        }).render();
    }
});
